<div class="main-content" [class.no-sidebar]="!showSidebar">
    <aside class="sidebar" *ngIf="showSidebar">
        <div class="sidebar-header">
            <h2>Acciones</h2>
            <p>Selecciona una operación</p>
        </div>

        <div class="tabs" role="tablist" aria-label="Seleccionar operación: Firmar o Verificar documentos">
            <button
                *ngIf="availableTabs.includes('sign')"
                class="tab" 
                [class.active]="activeTab === 'sign'" 
                (click)="setActiveTab('sign')"
                role="tab"
                [attr.aria-selected]="activeTab === 'sign'"
                aria-controls="sign-panel"
                id="sign-tab"
                [attr.tabindex]="activeTab === 'sign' ? 0 : -1"
                type="button">
                <div class="tab-icon" aria-hidden="true">
                    <i class="fas fa-pen-nib"></i>
                </div>
                <div class="tab-content">
                    <div class="tab-title">Firmar</div>
                    <div class="tab-description">Firma documentos PDF o archivos</div>
                </div>
            </button>
            <button
                *ngIf="availableTabs.includes('verify')"
                class="tab" 
                [class.active]="activeTab === 'verify'" 
                (click)="setActiveTab('verify')"
                role="tab"
                [attr.aria-selected]="activeTab === 'verify'"
                aria-controls="verify-panel"
                id="verify-tab"
                [attr.tabindex]="activeTab === 'verify' ? 0 : -1"
                type="button">
                <div class="tab-icon" aria-hidden="true">
                    <i class="fas fa-certificate"></i>
                </div>
                <div class="tab-content">
                    <div class="tab-title">Verificar</div>
                    <div class="tab-description">Verifica firmas digitales</div>
                </div>
            </button>
        </div>
    </aside>
    
    <!-- ÁREA DE TRABAJO -->
    <main class="workspace">
        <!-- SECCIÓN: FIRMAR -->
        <div *ngIf="activeTab === 'sign'" class="content-section active view-soft-in" id="sign-panel" role="tabpanel" aria-labelledby="sign-tab">
            <div class="content-scroll">
            <div class="workspace-header">
                <h1>Firmar documentos · {{ signMechanismLabel }}</h1>
                <p>{{ signMechanismDescription }}</p>
            </div>

            <!-- Certifirma Físico: complemento no detectado (solo esta vista, sin pasos de firma) -->
            <div *ngIf="showTokenFisicoNotAvailableView" class="step-container lap-step-host">
                <app-local-agent-unavailable-panel
                    [loading]="agentChecking"
                    loadingMessage="Comprobando si el complemento está en ejecución…"
                    featureTag="Firma con Certifirma Digital Físico"
                    [downloadUrl]="agentDownloadUrl"
                    (obtain)="openAgentDownload()"
                    (refresh)="checkAgentAvailability()">
                </app-local-agent-unavailable-panel>
            </div>

            <!-- Flujo normal de firma (cuando no es Certifirma Digital Físico o cuando el agente está disponible) -->
            <ng-container *ngIf="!showTokenFisicoNotAvailableView">
            <!-- Timeline de progreso (horizontal, sin <ol> para evitar estilos globales) -->
            <nav class="sign-progress" id="tour-target-sign-progress" aria-label="Progreso del flujo de firma">
                <div class="sign-progress-list" role="list">
                    <div class="sign-progress-item"
                        role="listitem"
                        [class.is-current]="signFlowStep === 1"
                        [class.is-done]="signFlowStep > 1">
                        <span class="sign-progress-icon" aria-hidden="true"><i class="fas fa-cloud-arrow-up"></i></span>
                        <span class="sign-progress-copy">
                            <span class="sign-progress-title">Cargar</span>
                            <span class="sign-progress-desc">PDF u otro</span>
                        </span>
                    </div>
                    <span class="sign-progress-connector" aria-hidden="true" [class.is-done]="signFlowStep > 1"></span>
                    <div class="sign-progress-item"
                        role="listitem"
                        [class.is-current]="signFlowStep === 2"
                        [class.is-done]="signFlowStep > 2">
                        <span class="sign-progress-icon" aria-hidden="true"><i class="fas fa-list-check"></i></span>
                        <span class="sign-progress-copy">
                            <span class="sign-progress-title">Revisar</span>
                            <span class="sign-progress-desc">Cola</span>
                        </span>
                    </div>
                    <span class="sign-progress-connector" aria-hidden="true" [class.is-done]="signFlowStep > 2"></span>
                    <div class="sign-progress-item"
                        role="listitem"
                        [class.is-current]="signFlowStep === 3"
                        [class.is-done]="false">
                        <span class="sign-progress-icon" aria-hidden="true"><i class="fas fa-pen-nib"></i></span>
                        <span class="sign-progress-copy">
                            <span class="sign-progress-title">{{ isSignCredentialsReady || showTokenFisicoSignFlow ? 'Firmar' : 'Continuar' }}</span>
                            <span class="sign-progress-desc">Finalizar</span>
                        </span>
                    </div>
                </div>
            </nav>

            <div class="sign-work-grid">
            <!-- IZQUIERDA: carga -->
            <div class="step-container sign-upload-panel" id="tour-target-sign-upload">
                <div class="step-header">
                    <div class="step-title">
                        <h3>Paso 1: Selecciona el tipo de documento</h3>
                        <p>PDF (recomendado para contratos) o archivo general (CAdES)</p>
                    </div>
                </div>

                <div class="file-type-selector" role="group" aria-label="Seleccionar y cargar archivos a firmar">
                    <button
                        class="file-type-option file-type-drop"
                        type="button"
                        [class.selected]="signFileType === 'pdf' && signFiles.length === 0"
                        [class.has-loaded-files]="signFileType === 'pdf' && signFiles.length > 0"
                        [class.drag-over]="signDropTarget === 'pdf'"
                        (click)="onFileTypeCardClick('pdf')"
                        (drop)="onFileTypeDrop($event, 'pdf')"
                        (dragover)="onFileTypeDragOver($event, 'pdf')"
                        (dragleave)="onFileTypeDragLeave($event, 'pdf')"
                        [attr.aria-label]="'PDF: haz clic o arrastra archivos PDF. La firma queda dentro del mismo PDF.' + (signFileType === 'pdf' && signFiles.length > 0 ? ' ' + signFiles.length + ' archivo(s) cargado(s).' : '')">
                        <div class="file-type-icon" aria-hidden="true">
                            <i class="fas fa-file-pdf"></i>
                        </div>
                        <div class="file-type-content">
                            <div class="file-type-label">PDF</div>
                            <div class="file-type-description">Recomendado para contratos · firma dentro del PDF</div>
                            <div class="file-type-limit-hint">{{ signFileLimitHint }}</div>
                            <div class="file-type-action-hint" *ngIf="!(signFileType === 'pdf' && signFiles.length > 0)">
                                Clic o arrastra aquí
                            </div>
                            <div class="file-type-loaded-status" *ngIf="signFileType === 'pdf' && signFiles.length > 0">
                                <i class="fas fa-check-circle" aria-hidden="true"></i>
                                {{ signFiles.length }} archivo{{ signFiles.length === 1 ? '' : 's' }} listo{{ signFiles.length === 1 ? '' : 's' }}
                            </div>
                        </div>
                    </button>

                    <button
                        class="file-type-option file-type-drop"
                        type="button"
                        [class.selected]="signFileType === 'other' && signFiles.length === 0"
                        [class.has-loaded-files]="signFileType === 'other' && signFiles.length > 0"
                        [class.drag-over]="signDropTarget === 'other'"
                        (click)="onFileTypeCardClick('other')"
                        (drop)="onFileTypeDrop($event, 'other')"
                        (dragover)="onFileTypeDragOver($event, 'other')"
                        (dragleave)="onFileTypeDragLeave($event, 'other')"
                        [attr.aria-label]="'Otro archivo: haz clic o arrastra cualquier archivo. Genera un archivo firmado .p7z.' + (signFileType === 'other' && signFiles.length > 0 ? ' ' + signFiles.length + ' archivo(s) cargado(s).' : '')">
                        <div class="file-type-icon" aria-hidden="true">
                            <i class="fas fa-file-alt"></i>
                        </div>
                        <div class="file-type-content">
                            <div class="file-type-label">Otro Archivo</div>
                            <div class="file-type-description">Genera un archivo firmado .p7z</div>
                            <div class="file-type-limit-hint">{{ signFileLimitHint }}</div>
                            <div class="file-type-action-hint" *ngIf="!(signFileType === 'other' && signFiles.length > 0)">
                                Clic o arrastra aquí
                            </div>
                            <div class="file-type-loaded-status" *ngIf="signFileType === 'other' && signFiles.length > 0">
                                <i class="fas fa-check-circle" aria-hidden="true"></i>
                                {{ signFiles.length }} archivo{{ signFiles.length === 1 ? '' : 's' }} listo{{ signFiles.length === 1 ? '' : 's' }}
                            </div>
                        </div>
                    </button>
                </div>

                <input
                    #pdfFileInput
                    type="file"
                    class="file-input"
                    multiple
                    accept=".pdf,application/pdf"
                    (change)="onSignFilesSelected($event)"
                    aria-label="Seleccionar archivos PDF"
                    aria-describedby="file-input-help-pdf">
                <span id="file-input-help-pdf" class="sr-only">
                    Selecciona uno o más archivos PDF. Máximo {{ signMaxFileSizeMb }}MB cada uno.
                </span>
                <input
                    #otherFileInput
                    type="file"
                    class="file-input"
                    multiple
                    (change)="onSignFilesSelected($event)"
                    aria-label="Seleccionar archivos"
                    aria-describedby="file-input-help-other">
                <span id="file-input-help-other" class="sr-only">
                    Selecciona uno o más archivos. Máximo {{ signMaxFileSizeMb }}MB cada uno.
                </span>
            </div>

            <!-- DERECHA: cola de archivos -->
            <aside class="step-container sign-queue-panel" id="tour-target-sign-queue" #signFilesStep aria-label="Cola de archivos">
                <div class="sign-queue-header">
                    <div class="sign-queue-title-block">
                        <h3>Cola de archivos</h3>
                        <p *ngIf="signFiles.length === 0">Los archivos que cargues aparecerán aquí</p>
                        <p *ngIf="signFiles.length > 0">
                            {{ signFiles.length }} archivo{{ signFiles.length === 1 ? '' : 's' }}
                            <ng-container *ngIf="signFileType === 'pdf'"> · configura firma visible si la necesitas</ng-container>
                        </p>
                    </div>
                    <button
                        *ngIf="signFiles.length > 0"
                        class="btn-clear-subtle"
                        (click)="clearAllSignFiles(); $event.stopPropagation()"
                        type="button"
                        aria-label="Limpiar todos los archivos seleccionados"
                        title="Limpiar todo">
                        Limpiar
                    </button>
                </div>

                <div class="sign-queue-empty" *ngIf="signFiles.length === 0">
                    <div class="sign-queue-empty-icon" aria-hidden="true"><i class="fas fa-inbox"></i></div>
                    <p class="sign-queue-empty-title">Sin archivos aún</p>
                    <p class="sign-queue-empty-desc">Arrastra un PDF u otro archivo a la izquierda para empezar.</p>
                </div>

                <div
                    class="drop-zone has-files sign-files-panel"
                    *ngIf="signFiles.length > 0"
                    (drop)="onSignDrop($event)"
                    (dragover)="onDragOver($event)"
                    role="region"
                    [attr.aria-label]="signFileType === 'pdf' ? 'Archivos PDF seleccionados' : 'Archivos seleccionados'">

                    <div class="drop-zone-files">
                        <!-- MVP: UI TSA/LTV fuera de alcance; quitar *ngIf="false" en otra rama. -->
                        <div class="sign-tsa-ltv-bar" *ngIf="false" (click)="$event.stopPropagation()">
                            <label
                                class="pdf-visible-switch-row"
                                [class.pdf-visible-switch-row--on]="signTimestampEnabled">
                                <input
                                    type="checkbox"
                                    class="pdf-visible-switch-input"
                                    role="switch"
                                    [attr.aria-checked]="signTimestampEnabled ? 'true' : 'false'"
                                    [checked]="signTimestampEnabled"
                                    (change)="setSignTimestampEnabled($any($event.target).checked)"
                                    aria-label="Estampa de tiempo TSA" />
                                <span class="pdf-visible-switch-ui" aria-hidden="true">
                                    <span class="pdf-visible-switch-track"></span>
                                    <span class="pdf-visible-switch-thumb">
                                        <i class="fas fa-clock pdf-visible-switch-thumb-icon" aria-hidden="true"></i>
                                    </span>
                                </span>
                                <span class="pdf-visible-switch-copy">
                                    <span class="pdf-visible-switch-title">Estampa de tiempo (TSA)</span>
                                    <span class="pdf-visible-switch-hint">{{ signTimestampEnabled ? 'Se solicitará estampa al firmar' : 'Sin estampa de tiempo' }}</span>
                                </span>
                            </label>
                            <label
                                *ngIf="signFileType === 'pdf'"
                                class="pdf-visible-switch-row"
                                [class.pdf-visible-switch-row--on]="signLtvEnabled"
                                [class.pdf-visible-switch-row--disabled]="!signTimestampEnabled">
                                <input
                                    type="checkbox"
                                    class="pdf-visible-switch-input"
                                    role="switch"
                                    [attr.aria-checked]="signLtvEnabled ? 'true' : 'false'"
                                    [checked]="signLtvEnabled"
                                    [disabled]="!signTimestampEnabled"
                                    (change)="setSignLtvEnabled($any($event.target).checked)"
                                    aria-label="Activar LTV en PDF" />
                                <span class="pdf-visible-switch-ui" aria-hidden="true">
                                    <span class="pdf-visible-switch-track"></span>
                                    <span class="pdf-visible-switch-thumb">
                                        <i class="fas fa-shield-alt pdf-visible-switch-thumb-icon" aria-hidden="true"></i>
                                    </span>
                                </span>
                                <span class="pdf-visible-switch-copy">
                                    <span class="pdf-visible-switch-title">LTV</span>
                                    <span class="pdf-visible-switch-hint">{{ signLtvEnabled ? 'Evidencia de revocación embebida' : (signTimestampEnabled ? 'Sin LTV' : 'Requiere TSA') }}</span>
                                </span>
                            </label>
                        </div>
                        <div
                            class="file-item-inline"
                            *ngFor="let file of signFiles; let i = index"
                            [class.file-item-pdf-stacked]="signFileType === 'pdf'">
                            <div
                                *ngIf="signFileType === 'pdf'"
                                class="file-item-pdf-toolbar"
                                (click)="$event.stopPropagation()">
                                <div
                                    class="pdf-visible-block"
                                    [class.pdf-visible-block--pending]="pdfWantVisibleSignature[i] && !isPdfVisibleReady(i)"
                                    [class.pdf-visible-block--ready]="pdfWantVisibleSignature[i] && isPdfVisibleReady(i)">
                                    <label
                                        class="pdf-visible-switch-row"
                                        [class.pdf-visible-switch-row--on]="pdfWantVisibleSignature[i]"
                                        (click)="$event.stopPropagation()">
                                        <input
                                            type="checkbox"
                                            class="pdf-visible-switch-input"
                                            role="switch"
                                            [attr.aria-checked]="pdfWantVisibleSignature[i] ? 'true' : 'false'"
                                            [checked]="pdfWantVisibleSignature[i]"
                                            (change)="setPdfWantVisibleSignature(i, $any($event.target).checked)"
                                            [attr.aria-label]="'Firma visible en el PDF ' + file.name" />
                                        <span class="pdf-visible-switch-ui" aria-hidden="true">
                                            <span class="pdf-visible-switch-track"></span>
                                            <span class="pdf-visible-switch-thumb">
                                                <i class="fas fa-stamp pdf-visible-switch-thumb-icon" aria-hidden="true"></i>
                                            </span>
                                        </span>
                                        <span class="pdf-visible-switch-copy">
                                            <span class="pdf-visible-switch-title">Firma visible</span>
                                            <span class="pdf-visible-switch-hint">{{ pdfWantVisibleSignature[i] ? (isPdfVisibleReady(i) ? 'Dibujar zona de firma configurada' : 'Pulsa «Dibujar zona de firma» para marcar el área') : 'Sin apariencia en hoja' }}</span>
                                        </span>
                                    </label>
                                    <button
                                        *ngIf="pdfWantVisibleSignature[i] && !isPdfVisibleReady(i)"
                                        type="button"
                                        class="btn btn-primary btn-define-zone-app"
                                        (click)="openFirmaVisibleModalForSinglePdf(i); $event.stopPropagation()">
                                        <i class="fas fa-vector-square" aria-hidden="true"></i>
                                        Dibujar zona de firma
                                    </button>
                                    <div *ngIf="pdfWantVisibleSignature[i] && isPdfVisibleReady(i)" class="pdf-visible-ready-strip">
                                        <span class="pdf-visible-ready-msg">
                                            <i class="fas fa-check-circle" aria-hidden="true"></i>
                                            Listo para firmar con firma visible
                                        </span>
                                        <button
                                            type="button"
                                            class="btn-edit-visible-zone"
                                            (click)="openFirmaVisibleModalForSinglePdf(i); $event.stopPropagation()">
                                            Editar zona
                                        </button>
                                    </div>
                                </div>
                            </div>
                            <div class="file-item-body-row">
                                <div class="file-icon-inline" aria-hidden="true">
                                    <i class="fas fa-file-pdf" *ngIf="signFileType === 'pdf'"></i>
                                    <i class="fas fa-file-alt" *ngIf="signFileType === 'other'"></i>
                                </div>
                                <div class="file-info-inline">
                                    <div class="file-name-inline" [attr.title]="file.name">{{ file.name }}</div>
                                    <div class="file-size-inline">{{ formatFileSize(file.size) }}</div>
                                </div>
                                <span class="sign-queue-status is-ready" *ngIf="signFileType !== 'pdf' || !pdfWantVisibleSignature[i] || isPdfVisibleReady(i)">Listo</span>
                                <span class="sign-queue-status is-pending" *ngIf="signFileType === 'pdf' && pdfWantVisibleSignature[i] && !isPdfVisibleReady(i)">Pendiente</span>
                                <button
                                    class="file-remove-inline"
                                    (click)="removeSignFile(i); $event.stopPropagation()"
                                    [attr.aria-label]="'Eliminar archivo ' + file.name"
                                    type="button"
                                    title="Eliminar archivo">
                                    <i class="fas fa-times"></i>
                                </button>
                            </div>
                        </div>
                        <p class="drop-zone-firma-visible-alert" *ngIf="signFileType === 'pdf' && hasPdfVisiblePendingConfiguration()" role="alert">
                            <i class="fas fa-exclamation-circle" aria-hidden="true"></i>
                            Completa la zona en cada PDF con firma visible activada para poder continuar.
                        </p>
                        <button
                            type="button"
                            class="drop-zone-add-more"
                            *ngIf="signFiles.length < 10"
                            (click)="openSignFilePicker()">
                            <i class="fas fa-plus" aria-hidden="true"></i>
                            <span>Agregar más archivos</span>
                        </button>
                    </div>
                </div>

                <div class="sign-queue-footer" *ngIf="signFiles.length > 0">
                    {{ signFiles.length }} de 10 archivos
                </div>
            </aside>
            </div><!-- /.sign-work-grid -->

            <!-- PASO: TIPO DE CERTIFICADO (oculto cuando el mecanismo se elige en el sidebar - Propuesta 5B) -->
            <div class="step-container" *ngIf="!isShellLayout">
                <div class="step-header">
                    <div class="step-title">
                        <h3>Tipo de Certificado</h3>
                        <p>Selecciona el origen de tu certificado digital</p>
                    </div>
                </div>

                <div class="certificate-selector" role="radiogroup" aria-label="Seleccionar tipo de certificado digital">

                    <button
                        class="certificate-option" 
                        [class.selected]="signCertificateType === 'token'"
                        (click)="selectSignCertificateType('token')"
                        role="radio"
                        [attr.aria-checked]="signCertificateType === 'token'"
                        [attr.tabindex]="signCertificateType === 'token' ? 0 : -1"
                        type="button"
                        aria-label="Certifirma Digital Virtual - Certificado almacenado en servidor">
                        <div class="certificate-label">Certifirma Digital Virtual</div>
                    </button>

                    <button
                        class="certificate-option" 
                        [class.selected]="signCertificateType === 'p10'"
                        (click)="selectSignCertificateType('p10')"
                        role="radio"
                        [attr.aria-checked]="signCertificateType === 'p10'"
                        [attr.tabindex]="signCertificateType === 'p10' ? 0 : -1"
                        type="button"
                        aria-label="Certifirma Digital PKCS10 - Certificado desde archivo local">
                        <div class="certificate-label">Certifirma Digital PKCS10</div>
                    </button>

                    
                </div>
            </div>

            </ng-container>
            </div><!-- /.content-scroll -->
        </div><!-- /.content-section sign-panel -->

            <!-- BOTONES DE ACCIÓN (fijos al pie del workspace, fuera del scroll) -->
            <div class="action-buttons workspace-footer-actions" id="tour-target-sign-actions" *ngIf="activeTab === 'sign' && !showTokenFisicoNotAvailableView">
                <button 
                    class="btn btn-secondary" 
                    (click)="cancelSign()"
                    type="button"
                    aria-label="Cancelar proceso de firma y limpiar archivos seleccionados">
                    Cancelar
                </button>
                <button 
                    class="btn btn-primary" 
                    [disabled]="isSignPrimaryActionDisabled"
                    (click)="signDocuments()"
                    type="button"
                    [title]="signFileType === 'pdf' && hasPdfVisiblePendingConfiguration() ? 'Define la zona de firma en cada PDF con firma visible antes de continuar.' : null"
                    [attr.aria-label]="signPrimaryActionAriaLabel"
                    [attr.aria-disabled]="isSignPrimaryActionDisabled"
                    [attr.aria-describedby]="signFileType === 'pdf' && hasPdfVisiblePendingConfiguration() ? 'sign-pending-visible-hint' : null">
                    {{ signPrimaryActionLabel }}
                </button>
                <span id="sign-pending-visible-hint" class="sr-only" *ngIf="signFileType === 'pdf' && hasPdfVisiblePendingConfiguration()">
                    Completa la zona de firma en todos los PDF marcados con firma visible para habilitar el botón.
                </span>
            </div>

        <!-- SECCIÓN: VERIFICAR (compacta / estilo Adobe) -->
        <div *ngIf="activeTab === 'verify'" class="content-section active view-soft-in verify-workspace" id="verify-panel" role="tabpanel" aria-labelledby="verify-tab">
            <div class="workspace-header verify-workspace-header">
                <h1>Verificar autenticidad de firma</h1>
                <p>Comprueba la validez y autenticidad de tu documento firmado digitalmente.</p>
            </div>

            <!-- Carga compacta (antes del resultado) -->
            <ng-container *ngIf="!verificationResult">
                <div class="verify-upload" id="tour-target-verify-upload">
                    <div
                        class="drop-zone verify-drop"
                        [class.has-files]="verifyFile"
                        (click)="verifyFileInput.click()"
                        (drop)="onVerifyDrop($event)"
                        (dragover)="onDragOver($event)"
                        role="button"
                        tabindex="0"
                        aria-label="Zona para arrastrar documento firmado o hacer clic para seleccionar. Acepta PDF, .p7z, .p7m o .xml"
                        (keydown.enter)="verifyFileInput.click()"
                        (keydown.space)="verifyFileInput.click(); $event.preventDefault()">

                        <div *ngIf="!verifyFile" class="drop-zone-empty">
                            <div class="drop-zone-icon" aria-hidden="true">
                                <img src="assets/icons/upload-icon.svg" alt="" class="drop-zone-icon-img" />
                            </div>
                            <div class="drop-zone-text">Selecciona o arrastra tu archivo firmado (.pdf, .p7z o .xml)</div>
                            <div class="drop-zone-hint">Máximo 10&nbsp;MB por documento</div>
                            <div class="verify-chip-row" aria-hidden="true">
                                <span class="verify-chip">.pdf</span>
                                <span class="verify-chip">.p7z</span>
                                <span class="verify-chip">.p7m</span>
                                <span class="verify-chip">.xml</span>
                            </div>
                        </div>

                        <div *ngIf="verifyFile" class="drop-zone-filled">
                            <div class="file-item-inline">
                                <div class="file-icon-inline" [class.verify-file-ico-cades]="!isVerifyFilePdf">
                                    <i class="fas" [ngClass]="isVerifyFilePdf ? 'fa-file-pdf' : (isVerifyFileXml ? 'fa-file-code' : 'fa-file-archive')"></i>
                                </div>
                                <div class="file-info-inline">
                                    <div class="file-name-inline">{{ verifyFile.name }}</div>
                                    <div class="file-size-inline">{{ formatFileSize(verifyFile.size) }} · listo para verificar</div>
                                </div>
                                <button
                                    class="file-remove-inline"
                                    (click)="resetVerify(); $event.stopPropagation()"
                                    type="button"
                                    aria-label="Eliminar archivo">
                                    <i class="fas fa-times"></i>
                                </button>
                            </div>
                        </div>

                        <input
                            #verifyFileInput
                            type="file"
                            class="file-input"
                            accept=".pdf,.p7z,.p7m,.xml,application/xml,text/xml"
                            (change)="onVerifyFileSelected($event)"
                            aria-label="Seleccionar documento firmado para verificar"
                            aria-describedby="verify-file-input-help">
                        <span id="verify-file-input-help" class="sr-only">
                            Selecciona un PDF firmado, un archivo .p7z / .p7m o un XML XAdES (.xml). Máximo 10MB.
                        </span>
                    </div>

                    <div class="action-buttons action-buttons-right verify-upload-actions" id="tour-target-verify-actions" *ngIf="verifyFile">
                        <ng-container *ngIf="verifyStateService.state$ | async as verifyState">
                            <button
                                class="btn btn-primary"
                                (click)="verifySignature()"
                                type="button"
                                [disabled]="verifyState.isProcessing"
                                [attr.aria-busy]="verifyState.isProcessing"
                                aria-label="Validar documento firmado">
                                <span *ngIf="verifyState.isProcessing">Validando…</span>
                                <span *ngIf="!verifyState.isProcessing">Validar documento</span>
                            </button>
                        </ng-container>
                    </div>
                </div>
            </ng-container>

            <!-- Resultado: barra fina + visor compacto + panel -->
            <ng-container *ngIf="verifyFile && verificationResult">
                <div
                    id="verify-result-region"
                    class="verify-bar"
                    tabindex="-1"
                    [class.error]="!verificationResult.valid"
                    role="status"
                    [attr.aria-live]="verificationResult.valid ? 'polite' : 'assertive'"
                    aria-atomic="true"
                    aria-label="Resultado de la verificación de firmas">
                    <div class="verify-bar-left">
                        <div class="verify-bar-icon" [class.error]="!verificationResult.valid" aria-hidden="true">
                            <i class="fas" [ngClass]="verificationResult.valid ? 'fa-circle-check' : 'fa-circle-xmark'"></i>
                        </div>
                        <div class="verify-bar-copy">
                            <span class="verify-bar-text">
                                {{ verificationResult.valid
                                    ? verifySuccessBarText
                                    : 'No fue posible validar las firmas del documento.' }}
                            </span>
                            <span class="verify-bar-sub">
                                <ng-container *ngIf="certificateList.length > 0">
                                    {{ certificateList.length === 1 ? '1 firma' : certificateList.length + ' firmas' }}
                                    <span aria-hidden="true"> · </span>
                                </ng-container>
                                Última comprobación: {{ formatLastCheckDate(verifyLastCheckDate) }}
                            </span>
                        </div>
                    </div>
                    <button
                        type="button"
                        class="btn-panel"
                        (click)="toggleVerifyPanel()"
                        [attr.aria-expanded]="verifyPanelOpen"
                        aria-label="Alternar panel de firmas"
                        *ngIf="isVerifyFilePdf && certificateList.length > 0">
                        {{ verifyPanelOpen ? 'Ocultar panel' : 'Panel de firmas' }}
                    </button>
                </div>

                <div class="verify-panel-backdrop"
                     *ngIf="isVerifyFilePdf && verifyPanelOpen && certificateList.length > 0"
                     (click)="toggleVerifyPanel()"
                     role="button"
                     tabindex="-1"
                     aria-label="Cerrar panel de firmas"
                     [attr.aria-hidden]="!verifyPanelOpen"></div>

                <ng-template #verifyFirmaListTpl>
                    <div
                        *ngFor="let cert of certificateList; let i = index"
                        class="verify-firma-item"
                        [class.expanded]="selectedRowIndex === i"
                        [class.verify-firma-item--error]="cert.success === false || !verificationResult.valid">
                        <div class="verify-firma-item-header" (click)="selectDetail(cert, i)">
                            <div class="verify-firma-item-icon" [class.error]="cert.success === false || !verificationResult.valid">
                                <i class="fas" [ngClass]="(cert.success !== false && verificationResult.valid) ? 'fa-circle-check' : 'fa-circle-xmark'"></i>
                            </div>
                            <div class="verify-firma-item-copy">
                                <span class="verify-firma-item-title">{{ cert.titular }}</span>
                                <span class="verify-firma-item-sub">
                                    {{ (cert.success !== false && verificationResult.valid) ? 'Firma válida' : 'Firma no válida' }}
                                    <ng-container *ngIf="cert.fechaFirma"> · {{ formatVerifyDate(cert.fechaFirma) }}</ng-container>
                                </span>
                            </div>
                            <span class="verify-firma-item-chevron"><i class="fas fa-chevron-down"></i></span>
                        </div>
                        <div class="verify-firma-item-body" *ngIf="selectedRowIndex === i">
                            <p class="verify-firma-summary">
                                {{ verificationResult.valid || cert.success ? 'La firma es válida:' : 'La firma no pudo validarse.' }}
                            </p>
                            <ul class="verify-firma-bullets" *ngIf="verificationResult.valid || cert.success">
                                <li>No ha habido modificaciones en el documento desde que se firmó.</li>
                                <li>La identidad del firmante es válida.</li>
                            </ul>
                            <p class="verify-firma-detail-line" *ngIf="cert.serviceMessage && !cert.success">{{ cert.serviceMessage }}</p>
                            <div class="verify-firma-meta">
                                <div class="verify-firma-kv" *ngIf="cert.serial && cert.serial !== 'N/A'">
                                    <span class="verify-firma-k">Serial</span>
                                    <span class="verify-firma-v">{{ cert.serial }}</span>
                                </div>
                                <div class="verify-firma-kv" *ngIf="cert.emisor && cert.emisor !== 'N/A'">
                                    <span class="verify-firma-k">Emisor</span>
                                    <span class="verify-firma-v">{{ formatDnSummary(cert.emisor) }}</span>
                                </div>
                                <div class="verify-firma-kv" *ngIf="cert.validoDesde && cert.validoDesde !== 'N/A'">
                                    <span class="verify-firma-k">Válido desde</span>
                                    <span class="verify-firma-v">{{ formatVerifyDate(cert.validoDesde) }}</span>
                                </div>
                                <div class="verify-firma-kv" *ngIf="cert.validoHasta && cert.validoHasta !== 'N/A'">
                                    <span class="verify-firma-k">Válido hasta</span>
                                    <span class="verify-firma-v">{{ formatVerifyDate(cert.validoHasta) }}</span>
                                </div>
                            </div>
                            <div class="verify-firma-tsa-ltv">
                                <p class="verify-firma-detail-line">{{ getTimestampDetailText(cert) }}</p>
                                <p class="verify-firma-detail-line">{{ getLtvDetailText(cert) }}</p>
                            </div>
                            <div class="verify-firma-item-actions">
                                <button type="button" class="btn-link" (click)="openSignatureValidationModal(cert)">Ver estado de validación</button>
                                <button type="button" class="btn-link" (click)="openCertificateFor(cert, i)">Propiedades de la firma...</button>
                            </div>
                        </div>
                    </div>
                </ng-template>

                <div class="verify-layout-with-panel"
                     [class.verify-layout-panel-open]="isVerifyFilePdf && verifyPanelOpen && certificateList.length > 0"
                     [class.verify-layout-cades]="!isVerifyFilePdf">
                    <div class="verify-main-area">
                        <div class="verify-doc-viewer">
                            <div class="verify-doc-toolbar">
                                <span class="verify-doc-toolbar-name">{{ verifyFile.name }}</span>
                                <span class="verify-doc-toolbar-meta">{{ verifyFileFormatLabel }}</span>
                            </div>

                            <div class="verify-pdf-wrapper" *ngIf="isVerifyFilePdf && verifyFileObjectUrl">
                                <pdf-viewer
                                    [src]="verifyFileObjectUrl"
                                    [render-text]="true"
                                    [original-size]="false"
                                    [show-all]="true"
                                    style="display: block; width: 100%; height: 100%;">
                                </pdf-viewer>
                            </div>

                            <div class="verify-cades-stage" *ngIf="!isVerifyFilePdf && verifyFile">
                                <!-- Error sin firmantes -->
                                <div class="verify-cades-card verify-cades-card--error"
                                     *ngIf="!verificationResult.valid && certificateList.length === 0">
                                    <div class="verify-cades-head">
                                        <div class="verify-cades-ico" aria-hidden="true">
                                            <i class="fas fa-circle-exclamation"></i>
                                        </div>
                                        <h3 class="verify-cades-name">{{ verifyFile.name }}</h3>
                                        <p class="verify-cades-hint">
                                            {{ verificationResult.errores?.[0]?.serviceMessage
                                                || verificationResult.errores?.[0]?.message
                                                || 'No se pudo leer la firma del contenedor.' }}
                                        </p>
                                    </div>
                                </div>

                                <!-- Vista CAdES: lista + operaciones + detalle -->
                                <div class="cades-desk" *ngIf="certificateList.length > 0">
                                    <div class="cades-desk-file">
                                        <span class="cades-desk-file-ico" aria-hidden="true">
                                            <i class="fas" [ngClass]="isVerifyFileXml ? 'fa-file-code' : 'fa-file-archive'"></i>
                                        </span>
                                        <div class="cades-desk-file-copy">
                                            <strong>{{ verifyFile.name }}</strong>
                                            <span>
                                                {{ verifyFileFormatLabel }} · {{ formatFileSize(verifyFile.size) }} ·
                                                {{ certificateList.length === 1 ? '1 firma' : certificateList.length + ' firmas' }}
                                            </span>
                                        </div>
                                    </div>

                                    <section class="cades-desk-panel cades-desk-list" aria-label="Firmas asociadas al archivo">
                                        <header class="cades-desk-panel-head">Firmas asociadas al archivo</header>
                                        <div class="cades-desk-table-wrap">
                                            <table class="cades-desk-table">
                                                <thead>
                                                    <tr>
                                                        <th scope="col">Titular de la firma</th>
                                                        <th scope="col">Resultado de la validación</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <tr
                                                        *ngFor="let cert of certificateList; let i = index"
                                                        [class.selected]="selectedRowIndex === i"
                                                        [class.is-invalid]="cert.success === false || !verificationResult.valid"
                                                        (click)="selectCadesFirma(cert, i)"
                                                        (keydown.enter)="selectCadesFirma(cert, i)"
                                                        (keydown.space)="selectCadesFirma(cert, i); $event.preventDefault()"
                                                        tabindex="0"
                                                        [attr.aria-selected]="selectedRowIndex === i"
                                                        role="row">
                                                        <td>
                                                            <span class="cades-desk-titular">{{ cert.titular }}</span>
                                                        </td>
                                                        <td>
                                                            <span class="cades-desk-badge"
                                                                  [class.ok]="cert.success !== false && verificationResult.valid"
                                                                  [class.fail]="cert.success === false || !verificationResult.valid">
                                                                <i class="fas" [ngClass]="(cert.success !== false && verificationResult.valid) ? 'fa-circle-check' : 'fa-circle-xmark'" aria-hidden="true"></i>
                                                                {{ (cert.success !== false && verificationResult.valid) ? 'Firma válida' : 'Firma no válida' }}
                                                            </span>
                                                        </td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                    </section>

                                    <div class="cades-desk-bottom">
                                        <section class="cades-desk-panel cades-desk-ops" aria-label="Operaciones sobre el archivo">
                                            <header class="cades-desk-panel-head">Operaciones sobre el archivo</header>
                                            <ol class="cades-desk-ops-list">
                                                <li>
                                                    <p>Ver el contenido original del archivo</p>
                                                    <button type="button" class="btn btn-secondary cades-desk-btn"
                                                            (click)="downloadOriginalFile()">
                                                        Ver contenido…
                                                    </button>
                                                </li>
                                                <li>
                                                    <p>Firmar nuevamente el archivo verificado</p>
                                                    <button type="button" class="btn btn-primary cades-desk-btn"
                                                            (click)="signAgain()">
                                                        Firmar…
                                                    </button>
                                                </li>
                                            </ol>
                                        </section>

                                        <section class="cades-desk-panel cades-desk-details" aria-label="Detalles de la firma digital">
                                            <header class="cades-desk-panel-head">Detalles de la firma digital</header>
                                            <div class="cades-desk-details-empty" *ngIf="!selectedDetail">
                                                Selecciona una firma de la lista para ver sus detalles.
                                            </div>
                                            <div class="cades-desk-table-wrap" *ngIf="selectedDetail">
                                                <table class="cades-desk-table cades-desk-table--kv">
                                                    <thead>
                                                        <tr>
                                                            <th scope="col">Campo</th>
                                                            <th scope="col">Valor</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        <tr>
                                                            <th scope="row">Titular</th>
                                                            <td>{{ selectedDetail.titular }}</td>
                                                        </tr>
                                                        <tr *ngIf="selectedDetail.asunto && selectedDetail.asunto !== 'N/A'">
                                                            <th scope="row">Asunto</th>
                                                            <td>{{ formatDnSummary(selectedDetail.asunto) }}</td>
                                                        </tr>
                                                        <tr *ngIf="selectedDetail.emisor && selectedDetail.emisor !== 'N/A'">
                                                            <th scope="row">Emisor</th>
                                                            <td>{{ formatDnSummary(selectedDetail.emisor) }}</td>
                                                        </tr>
                                                        <tr *ngIf="selectedDetail.serial && selectedDetail.serial !== 'N/A'">
                                                            <th scope="row">Serial</th>
                                                            <td>{{ selectedDetail.serial }}</td>
                                                        </tr>
                                                        <tr>
                                                            <th scope="row">Fecha de firma</th>
                                                            <td>{{ formatVerifyDate(selectedDetail.fechaFirma) }}</td>
                                                        </tr>
                                                        <tr *ngIf="selectedDetail.validoDesde && selectedDetail.validoDesde !== 'N/A'">
                                                            <th scope="row">Válido desde</th>
                                                            <td>{{ formatVerifyDate(selectedDetail.validoDesde) }}</td>
                                                        </tr>
                                                        <tr *ngIf="selectedDetail.validoHasta && selectedDetail.validoHasta !== 'N/A'">
                                                            <th scope="row">Válido hasta</th>
                                                            <td>{{ formatVerifyDate(selectedDetail.validoHasta) }}</td>
                                                        </tr>
                                                        <tr>
                                                            <th scope="row">Estampa de tiempo</th>
                                                            <td>{{ getTimestampDetailText(selectedDetail) }}</td>
                                                        </tr>
                                                        <tr>
                                                            <th scope="row">LTV</th>
                                                            <td>{{ getLtvDetailText(selectedDetail) }}</td>
                                                        </tr>
                                                        <tr *ngIf="selectedDetail.serviceMessage">
                                                            <th scope="row">Mensaje</th>
                                                            <td>{{ selectedDetail.serviceMessage }}</td>
                                                        </tr>
                                                    </tbody>
                                                </table>
                                            </div>
                                            <div class="cades-desk-details-actions" *ngIf="selectedDetail">
                                                <button type="button" class="btn-link" (click)="openSignatureValidationModal(selectedDetail)">
                                                    Ver estado de validación
                                                </button>
                                            </div>
                                        </section>
                                    </div>
                                </div>
                            </div>

                            <div class="empty-state empty-state-no-signatures verify-empty-inline"
                                 *ngIf="isVerifyFilePdf && certificateList.length === 0 && !isLoading"
                                 role="status"
                                 aria-live="polite"
                                 aria-atomic="true">
                                <div class="empty-state-illustration">
                                    <i class="fas fa-signature"></i>
                                </div>
                                <h3 class="empty-state-title">{{ verificationResult.valid === false ? 'No se pudo validar la firma' : 'No se encontraron firmas' }}</h3>
                                <p class="empty-state-description" *ngIf="verificationResult.valid === false && verificationResult.errores?.length">
                                    {{ verificationResult.errores?.[0]?.serviceMessage || verificationResult.errores?.[0]?.message }}
                                </p>
                                <p class="empty-state-description" *ngIf="verificationResult.valid !== false">
                                    El documento no contiene firmas digitales o no se pudieron leer correctamente.
                                </p>
                            </div>

                            <div class="verify-signature-zones-wrap" *ngIf="isVerifyFilePdf && certificateList.length > 0">
                                <p class="verify-doc-hint"><strong>Clic</strong> sobre una firma para ver validación o propiedades.</p>
                                <div class="verify-signature-zones">
                                    <div
                                        *ngFor="let cert of certificateList; let i = index"
                                        class="verify-signature-zone"
                                        [class.valid]="cert.success !== false && verificationResult.valid"
                                        [class.invalid]="cert.success === false || !verificationResult.valid"
                                        (click)="onSignatureZoneClick($event, cert, i)"
                                        [attr.aria-label]="'Firma ' + (i + 1) + ' de ' + certificateList.length + '. ' + cert.titular + '. Clic para menú.'"
                                        tabindex="0"
                                        (keydown.enter)="onSignatureZoneClick($event, cert, i)"
                                        (keydown.space)="onSignatureZoneClick($event, cert, i); $event.preventDefault()">
                                        <div class="verify-signature-zone-label">Firma digital</div>
                                        <div class="verify-signature-zone-name">{{ cert.titular }}</div>
                                        <div class="verify-signature-zone-date">{{ formatVerifyDate(cert.fechaFirma) }}</div>
                                        <div class="verify-signature-zone-serial" *ngIf="cert.serial && cert.serial !== 'N/A'">Serial {{ cert.serial }}</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <aside class="verify-panel-firmas verify-panel-drawer"
                           *ngIf="isVerifyFilePdf && verifyPanelOpen && certificateList.length > 0">
                        <div class="verify-panel-header">
                            <span class="verify-panel-title">Firmas <span class="verify-panel-count">{{ certificateList.length }}</span></span>
                            <button type="button" class="verify-panel-close" (click)="toggleVerifyPanel()" aria-label="Cerrar panel de firmas">
                                <i class="fas fa-times"></i>
                            </button>
                        </div>
                        <div class="verify-panel-body">
                            <ng-container *ngTemplateOutlet="verifyFirmaListTpl"></ng-container>
                        </div>
                    </aside>
                </div>

                <div
                    *ngIf="verifyContextMenuVisible && verifyContextMenuCert"
                    class="verify-context-menu"
                    [style.left.px]="verifyContextMenuX"
                    [style.top.px]="verifyContextMenuY"
                    role="menu"
                    (click)="$event.stopPropagation()">
                    <button type="button" class="verify-context-item" (click)="openSignatureValidationModal(verifyContextMenuCert)" role="menuitem">
                        <i class="fas" [ngClass]="verificationResult.valid ? 'fa-circle-check' : 'fa-circle-xmark'" [class.valid]="verificationResult.valid" [class.invalid]="!verificationResult.valid"></i>
                        <span>Ver estado de validación</span>
                    </button>
                    <button type="button" class="verify-context-item" (click)="openSignaturePropertiesFromContext()" role="menuitem">
                        <i class="fas fa-certificate"></i>
                        <span>Propiedades de la firma...</span>
                    </button>
                </div>

                <div class="verify-actions-row">
                    <div class="action-buttons action-buttons-right">
                        <button class="btn btn-secondary" (click)="resetVerify()" type="button" aria-label="Seleccionar otro archivo para verificar">
                            {{ isVerifyFilePdf ? 'Otro archivo' : 'Cerrar' }}
                        </button>
                        <button class="btn btn-primary" (click)="downloadSignedFile()" type="button" aria-label="Descargar documento firmado" *ngIf="verifyFile">
                            Descargar
                        </button>
                        <button class="btn btn-primary" (click)="signAgain()" type="button" aria-label="Firmar documento" *ngIf="isVerifyFilePdf && certificateList.length > 0">
                            Firmar
                        </button>
                    </div>
                </div>
            </ng-container>
        </div>
    </main>
</div>